import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import BtnWhite from '../../../Shared/Buttons/BtnWhite';
import Config from '../../../../Config';
import networkImg from './images/network.svg';
import radarImg from './images/radar.svg';
import rocketImg from './images/rocket.svg';
import addedMesh from './images/add-mesh-upgrade.svg';

const meshUpgrade = (props) => {
  const clickUpgradeBtn = () => {
    props.onClickMeshUpgradeBtn(!props.isMeshUpgrade);
  };

  return (
    <div className='meshUpgrade-holder'>
      <div className='meshUpgrade'>
        <p className='top-text'>לאינטרנט מהיר באמת, בכל פינה בבית</p>
        <h4 className='title'>
          <span className='color1'> סופר</span>
          <span className='colo2'>WiFi</span>
        </h4>
        <div className='descriptions'>
          <div className='desc'>
            <Image className='desc1' src={radarImg} />
            <span className='desc-text'>
              כיסוי <br />
              אופטימלי
            </span>
            <span className='separator'></span>
          </div>
          <div className='desc'>
            <Image className='desc2' src={rocketImg} />
            <span className='desc-text'>
              WiFi <br /> מהיר
            </span>
            <span className='separator'></span>
          </div>
          <div className='desc'>
            <Image className='desc3' src={networkImg} />
            <span className='desc-text'>
              גלישה <br />
              רציפה
            </span>
          </div>
        </div>
        <p className='price-wrapper'>
          <span className='price'>₪{Config.meshUpgradeCost} </span>
          <span className='text'>תוספת לחודש בלבד</span>
        </p>
        <p className='bottom-text'>מוצר זה הינו משלים לנתב</p>
        <BtnWhite
          text={props.isMeshUpgrade ? <Image src={addedMesh} alt='upgrade to super wifi' /> : 'להוספה'}
          onclick={() => {
            clickUpgradeBtn();
          }}
        />
      </div>
    </div>
  );
};

export default meshUpgrade;
